export const getAgeByDate = (dateString: string): number => {
  const currentDate: number = Date.now();
  const dateBirth: Date = new Date(dateString);

  const timeDiff: number = Math.abs(currentDate - dateBirth.getTime());
  const age: number = Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);

  return age;
};
